import alertMixin from 'shared/mixins/alertMixin';
import Click2CallSettingsAPI from 'dashboard/api/click2callSettings';

export default {
  mixins: [alertMixin],
  methods: {
    customTexts(item) {
      if (!item.custom_texts) return {};
      const textPrefix = `INTEGRATION_APPS.CUSTOM_TEXTS.${item.id.toUpperCase()}.`;
      return {
        connectButtonCaption: this.$t(`${textPrefix}ENABLE`),
        deleteMessage: this.$t(`${textPrefix}DELETE_MESSAGE`),
        deleteYes: this.$t(`${textPrefix}DELETE_YES`),
        deleteNo: this.$t(`${textPrefix}DELETE_NO`),
      };
    },

    async addApp(item) {
      let alertMessage;
      try {
        if (item.id === 'click_to_call') {
          await Click2CallSettingsAPI.enableClick2Call();
        }
        await this.$store.dispatch('integrations/createHook', {
          app_id: item.id,
          settings: {},
        });
        if (item.id === 'doc_signature') {
          await this.$store.dispatch('accounts/update', {
            additional_attributes: { document_signature_enabled: true },
          });
          alertMessage = this.$t(
            'INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.SUCCESS_MESSAGE'
          );
        } else {
          alertMessage = this.$t('INTEGRATION_APPS.ADD.API.SUCCESS_MESSAGE', {
            integrationName: item.name,
          });
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.message;
        alertMessage =
          errorMessage || this.$t('INTEGRATION_APPS.ADD.API.ERROR_MESSAGE');
      } finally {
        this.showAlert(alertMessage);
      }
    },

    async deleteApp(item) {
      let alertMessage;
      try {
        const selectedHook = item.hooks[0];
        if (selectedHook.app_id === 'click_to_call') {
          await Click2CallSettingsAPI.deleteSettings();
        }
        if (selectedHook.app_id === 'doc_signature') {
          await this.$store.dispatch('accounts/update', {
            additional_attributes: { document_signature_enabled: false },
          });
        }

        await this.$store.dispatch('integrations/deleteHook', {
          hookId: selectedHook.id,
          appId: selectedHook.app_id,
        });
        if (selectedHook.app_id === 'forms') {
          await this.$store.dispatch('accounts/setFormsEnabled', {
            accountId: this.$store.getters.getCurrentAccountId,
            enabled: false,
          });
        }
        alertMessage = this.$t('INTEGRATION_APPS.DELETE.API.SUCCESS_MESSAGE');
      } catch (error) {
        const errorMessage = error?.response?.data?.message;
        alertMessage =
          errorMessage || this.$t('INTEGRATION_APPS.DELETE.API.ERROR_MESSAGE');
      } finally {
        this.showAlert(alertMessage);
      }
    },
  },
};
